import { useQuery } from '@tanstack/react-query';
import { GenericQueryResponse } from '../models/dynamo.query.model';
import { CustomerRecord } from '../models/customer.models';
import { postAuthenticated } from './api';

export const useGetAllCustomers = (
  searchValue: string = '',
  body: BodyInit
) => {
  const url = `customers?firstName=${searchValue}`;
  const { isPending, error, data, refetch } = useQuery<
    GenericQueryResponse<CustomerRecord>
  >({
    queryKey: ['customers', searchValue, body],
    queryFn: async () => {
      return postAuthenticated<GenericQueryResponse<CustomerRecord>>(url, body);
    },
  });

  return {
    loading: isPending,
    error,
    data: data || undefined,
    refetch,
  };
};
